
import { Reducer, SliceCaseReducers } from "@reduxjs/toolkit";

import { fetchSystemInfoByIdThunk } from "../../../Store/Thunks/systemInfoByIds";
import { System } from "../..";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { RootState } from "../../../Store";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { AsyncEntityState, createForeignKeySelector } from "../../../Store/Thunks/asyncEntityStateUtil";
import { fetchStationConfigByStationIdsThunk } from "../../../Store/Thunks/stationConfigByIds";
import { StationConfig } from "./queryStationConfigs";


// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice({
  name: "stationConfig",
  reducers: {
    },
  fetchByIdsThunk: fetchStationConfigByStationIdsThunk,
  selectId:(stationConfig) => stationConfig.station_config_id
})

export const stationConfigReducer = reducer as Reducer<AsyncEntityState<StationConfig, number>>;

const selectState = (state: RootState) => state.graphQlData.stationConfigs;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectionStationConfigById, selectAll: SelectAllStationConfigs} = entityAdapter.getSelectors(selectState);

const stationConfigByIdFetcher = new EnqueueFetcher(fetchStationConfigByStationIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const upsertStationConfig = upsertMany;

export const dispatchFetchStationConfigById = stationConfigByIdFetcher.enqueueFetchById;

export const {selectEntitiesByForeignKey: selectStationConfigByStationId} = createForeignKeySelector<StationConfig, number, AsyncEntityState<StationConfig, number>, number>((state) => state.graphQlData?.stationConfigs, "station_id");
const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

// export const useSystemInfoById = entityByIdWithStatusHookFactory<System, number>(systemInfoByIdFetcher.enqueueFetchById, selectSystemInfoById, selectLoadingIds )